import { useAuth } from "hooks/useAuth";

/**
 * Pre-build AdminRoutes audit (2026-06): AdminRoutes has no route-level role guard.
 * When FDE-DC (TCI Manager) users mount AdminRoutes, org-admin-only pages must gate here.
 * Pages already gated: PromptsManagerPage, FdeRosterPage, DomainManagementPage,
 * TciInterrogatoryPage, AuditLogPage, AnalyticsPage,
 * SessionListPage, CandidateQueuePage, TciManager* routes.
 * FusionLead and LoopManager use RequireLauncherApp (G2a).
 */
export function useOrgAdminAccess() {
  const { userData, isGlobalAdmin } = useAuth();
  const canAccess = isGlobalAdmin || userData?.role === "admin";
  return { canAccess, isGlobalAdmin };
}
